import { getCustomerDetail } from '#api/confirmation_forms';
import LoadingSpinner from '#atoms/LoadingSpinner';
import { useQuery } from '@tanstack/react-query';
import NoResult from 'src/shared/components/NoResult';
import Item from './Item';

interface ItemListProps {
  personId: string;
  id: string;
}

const ItemList = ({ personId, id }: ItemListProps) => {
  const { data, isLoading } = useQuery(
    ['CUSTOMERDETAIL', personId, id],
    () =>
      getCustomerDetail({
        personId,
        id
      }),
    {
      enabled: !!personId && !!id
    }
  );

  if (!data) return null;

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (data.registeredLectures?.length === 0) {
    return <NoResult text="등록된 수업이 없습니다." />;
  }

  return (
    <div className="flex flex-col gap-24">
      {data.registeredLectures &&
        data.registeredLectures.map(item => {
          const list = data.registeredLectures;

          const previousRegisteredLectureId = list.findLast(
            lecture => lecture.exerciseRecordStatus === 3
          )?.id;

          return (
            <Item
              isGroup={data.lecture.isGroup}
              key={item.id}
              previousRegisteredLectureId={previousRegisteredLectureId}
              {...item}
            />
          );
        })}
    </div>
  );
};

export default ItemList;
